/*! @pentacode/ui v0.1.0 */
import { r as e } from "../../scene-8VKOJsMP.js";
import { i as t, n, t as r } from "../../polar-DGg71UsL.js";
import { r as i } from "../../theme-BDdgxk0M.js";
import { i as a, n as o, s, t as c } from "../../shared-CfvkKPnq.js";
// src/charts/presets/breakdown.ts
function l(l, { format: u = s, legend: d = !0, highlight: f } = {}) {
	let p = l.filter((e) => e.value > 0).sort((e, t) => t.value - e.value), m = p.reduce((e, t) => e + t.value, 0), h = a(p.map((e) => e.label), c(p), d, f);
	return e({
		theme: i,
		marks: [r({
			inset: 8,
			radiusRatio: .82,
			scales: {
				angle: null,
				radius: null
			},
			marks: [n(t(p, { value: "value" }), {
				innerRadius: ({ radius: e }) => e * .62,
				cornerRadius: 3,
				padAngle: () => .01,
				color: "label",
				key: "label"
			})]
		})],
		scales: {
			x: null,
			y: null
		},
		color: h,
		tooltip: o(u, m)
	});
}
export { l as breakdownChart };

//# sourceMappingURL=breakdown.js.map